// source: pbtypes/gen/flir_boson_driver/thermal_params.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_flir_boson_driver_range_pb = require('../../../pbtypes/gen/flir_boson_driver/range_pb.js');
goog.object.extend(proto, pbtypes_gen_flir_boson_driver_range_pb);
goog.exportSymbol('proto.flir_boson_driver.ThermalParams', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flir_boson_driver.ThermalParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flir_boson_driver.ThermalParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flir_boson_driver.ThermalParams.displayName = 'proto.flir_boson_driver.ThermalParams';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flir_boson_driver.ThermalParams.prototype.toObject = function(opt_includeInstance) {
  return proto.flir_boson_driver.ThermalParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flir_boson_driver.ThermalParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flir_boson_driver.ThermalParams.toObject = function(includeInstance, msg) {
  var f, obj = {
validRangeC: (f = msg.getValidRangeC()) && pbtypes_gen_flir_boson_driver_range_pb.Range.toObject(includeInstance, f),
warningRangeC: (f = msg.getWarningRangeC()) && pbtypes_gen_flir_boson_driver_range_pb.Range.toObject(includeInstance, f),
saturationRangeC: (f = msg.getSaturationRangeC()) && pbtypes_gen_flir_boson_driver_range_pb.Range.toObject(includeInstance, f),
clipRangeC: (f = msg.getClipRangeC()) && pbtypes_gen_flir_boson_driver_range_pb.Range.toObject(includeInstance, f),
emissivity: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
relativeHumidity: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
objectDistanceM: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flir_boson_driver.ThermalParams}
 */
proto.flir_boson_driver.ThermalParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flir_boson_driver.ThermalParams;
  return proto.flir_boson_driver.ThermalParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flir_boson_driver.ThermalParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flir_boson_driver.ThermalParams}
 */
proto.flir_boson_driver.ThermalParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_flir_boson_driver_range_pb.Range;
      reader.readMessage(value,pbtypes_gen_flir_boson_driver_range_pb.Range.deserializeBinaryFromReader);
      msg.setValidRangeC(value);
      break;
    case 2:
      var value = new pbtypes_gen_flir_boson_driver_range_pb.Range;
      reader.readMessage(value,pbtypes_gen_flir_boson_driver_range_pb.Range.deserializeBinaryFromReader);
      msg.setWarningRangeC(value);
      break;
    case 3:
      var value = new pbtypes_gen_flir_boson_driver_range_pb.Range;
      reader.readMessage(value,pbtypes_gen_flir_boson_driver_range_pb.Range.deserializeBinaryFromReader);
      msg.setSaturationRangeC(value);
      break;
    case 4:
      var value = new pbtypes_gen_flir_boson_driver_range_pb.Range;
      reader.readMessage(value,pbtypes_gen_flir_boson_driver_range_pb.Range.deserializeBinaryFromReader);
      msg.setClipRangeC(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setEmissivity(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setRelativeHumidity(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setObjectDistanceM(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flir_boson_driver.ThermalParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flir_boson_driver.ThermalParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flir_boson_driver.ThermalParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flir_boson_driver.ThermalParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValidRangeC();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_flir_boson_driver_range_pb.Range.serializeBinaryToWriter
    );
  }
  f = message.getWarningRangeC();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_flir_boson_driver_range_pb.Range.serializeBinaryToWriter
    );
  }
  f = message.getSaturationRangeC();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_flir_boson_driver_range_pb.Range.serializeBinaryToWriter
    );
  }
  f = message.getClipRangeC();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      pbtypes_gen_flir_boson_driver_range_pb.Range.serializeBinaryToWriter
    );
  }
  f = message.getEmissivity();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getRelativeHumidity();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getObjectDistanceM();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
};


/**
 * optional Range valid_range_c = 1;
 * @return {?proto.flir_boson_driver.Range}
 */
proto.flir_boson_driver.ThermalParams.prototype.getValidRangeC = function() {
  return /** @type{?proto.flir_boson_driver.Range} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_flir_boson_driver_range_pb.Range, 1));
};


/**
 * @param {?proto.flir_boson_driver.Range|undefined} value
 * @return {!proto.flir_boson_driver.ThermalParams} returns this
*/
proto.flir_boson_driver.ThermalParams.prototype.setValidRangeC = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flir_boson_driver.ThermalParams} returns this
 */
proto.flir_boson_driver.ThermalParams.prototype.clearValidRangeC = function() {
  return this.setValidRangeC(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flir_boson_driver.ThermalParams.prototype.hasValidRangeC = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Range warning_range_c = 2;
 * @return {?proto.flir_boson_driver.Range}
 */
proto.flir_boson_driver.ThermalParams.prototype.getWarningRangeC = function() {
  return /** @type{?proto.flir_boson_driver.Range} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_flir_boson_driver_range_pb.Range, 2));
};


/**
 * @param {?proto.flir_boson_driver.Range|undefined} value
 * @return {!proto.flir_boson_driver.ThermalParams} returns this
*/
proto.flir_boson_driver.ThermalParams.prototype.setWarningRangeC = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flir_boson_driver.ThermalParams} returns this
 */
proto.flir_boson_driver.ThermalParams.prototype.clearWarningRangeC = function() {
  return this.setWarningRangeC(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flir_boson_driver.ThermalParams.prototype.hasWarningRangeC = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Range saturation_range_c = 3;
 * @return {?proto.flir_boson_driver.Range}
 */
proto.flir_boson_driver.ThermalParams.prototype.getSaturationRangeC = function() {
  return /** @type{?proto.flir_boson_driver.Range} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_flir_boson_driver_range_pb.Range, 3));
};


/**
 * @param {?proto.flir_boson_driver.Range|undefined} value
 * @return {!proto.flir_boson_driver.ThermalParams} returns this
*/
proto.flir_boson_driver.ThermalParams.prototype.setSaturationRangeC = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flir_boson_driver.ThermalParams} returns this
 */
proto.flir_boson_driver.ThermalParams.prototype.clearSaturationRangeC = function() {
  return this.setSaturationRangeC(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flir_boson_driver.ThermalParams.prototype.hasSaturationRangeC = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Range clip_range_c = 4;
 * @return {?proto.flir_boson_driver.Range}
 */
proto.flir_boson_driver.ThermalParams.prototype.getClipRangeC = function() {
  return /** @type{?proto.flir_boson_driver.Range} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_flir_boson_driver_range_pb.Range, 4));
};


/**
 * @param {?proto.flir_boson_driver.Range|undefined} value
 * @return {!proto.flir_boson_driver.ThermalParams} returns this
*/
proto.flir_boson_driver.ThermalParams.prototype.setClipRangeC = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flir_boson_driver.ThermalParams} returns this
 */
proto.flir_boson_driver.ThermalParams.prototype.clearClipRangeC = function() {
  return this.setClipRangeC(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flir_boson_driver.ThermalParams.prototype.hasClipRangeC = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional float emissivity = 5;
 * @return {number}
 */
proto.flir_boson_driver.ThermalParams.prototype.getEmissivity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flir_boson_driver.ThermalParams} returns this
 */
proto.flir_boson_driver.ThermalParams.prototype.setEmissivity = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional float relative_humidity = 6;
 * @return {number}
 */
proto.flir_boson_driver.ThermalParams.prototype.getRelativeHumidity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flir_boson_driver.ThermalParams} returns this
 */
proto.flir_boson_driver.ThermalParams.prototype.setRelativeHumidity = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional float object_distance_m = 7;
 * @return {number}
 */
proto.flir_boson_driver.ThermalParams.prototype.getObjectDistanceM = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flir_boson_driver.ThermalParams} returns this
 */
proto.flir_boson_driver.ThermalParams.prototype.setObjectDistanceM = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


goog.object.extend(exports, proto.flir_boson_driver);
